<template>
  <div class="container">
    <div class="logo"></div>
    <div class="text">您好，欢迎登录“淅川政企通”</div>
    <!-- 输入框 -->
    <!-- <div class="box">
      <div class="icon">
        <svg
          t="1695866000014"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2694"
          width="20"
          height="20"
        >
          <path
            d="M798.723234 174.782745c0-60.576657-49.106418-109.683075-109.683075-109.683075l-354.708628 0c-60.576657 0-109.683075 49.106418-109.683075 109.683075l0 673.980161c0 60.576657 49.106418 109.683075 109.683075 109.683075l354.708628 0c60.576657 0 109.683075-49.106418 109.683075-109.683075L798.723234 174.782745zM264.557398 237.015112l494.256894 0 0 529.049305-494.256894 0L264.557398 237.015112zM334.356091 105.008612 689.016623 105.008612c38.548968 0 69.798692 31.249725 69.798692 69.798692l0 22.298865-494.256894 0 0-22.298865C264.557398 136.25936 295.807123 105.008612 334.356091 105.008612zM689.016623 918.53704 334.356091 918.53704c-38.548968 0-69.798692-31.249725-69.798692-69.798692l0-43.788296 494.256894 0 0 43.788296C758.814292 887.287315 727.564567 918.53704 689.016623 918.53704z"
            fill="#ffffff"
            p-id="2695"
          ></path>
          <path
            d="M513.173732 829.943282c-16.70752 0-30.30112 13.5936-30.30112 30.30112 0 16.70752 13.5936 30.30112 30.30112 30.30112s30.299073-13.5936 30.299073-30.30112C543.472805 843.536882 529.881253 829.943282 513.173732 829.943282z"
            fill="#ffffff"
            p-id="2696"
          ></path>
        </svg>
      </div>
      <input type="text" placeholder="请输入手机号" class="input_t" id="phone" />
    </div>
    <div class="box">
      <div class="icon">
        <svg
          t="1695870412783"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="5215"
          id="mx_n_1695870412785"
          width="20"
          height="20"
        >
          <path
            d="M891.306667 279.04c-2.133333-37.546667-29.44-68.693333-66.133334-75.946667-47.786667-7.253333-95.146667-18.346667-141.653333-32-44.8-17.92-86.613333-41.813333-124.586667-71.253333-30.72-20.48-71.68-18.773333-100.693333 4.693333-35.84 31.146667-78.08 54.613333-123.733333 67.84-43.52 17.92-89.173333 29.44-136.106667 33.706667-37.546667 4.693333-66.133333 35.84-67.84 73.813333v238.506667c3.413333 208.64 247.893333 420.693333 383.146667 420.693333 132.693333 0 342.613333-147.626667 374.613333-416.426666 5.546667-81.493333 6.4-162.56 2.986667-243.626667z m-70.4 236.8c-29.013333 235.946667-212.053333 354.56-306.773334 354.56-40.533333 0-119.893333-38.4-192.853333-111.786667-76.373333-76.8-120.746667-164.693333-122.453333-241.066666V281.6c0.426667-4.266667 3.84-7.68 7.68-8.106667 51.626667-5.12 102.4-17.493333 150.613333-37.12 52.906667-16.213333 102.826667-43.52 144.213333-79.786666 3.413333-2.56 7.253333-3.413333 9.813334-3.413334 2.133333 0 5.12 0.426667 8.106666 2.133334 42.24 32.426667 88.746667 58.88 138.24 78.506666l2.986667 1.28 2.986667 0.853334c48.64 14.506667 98.56 26.026667 148.906666 34.133333 5.973333 1.28 9.813333 6.4 10.666667 12.373333 3.413333 77.653333 2.56 156.16-2.133333 233.386667z"
            fill="#E3E3E3"
            p-id="5216"
          ></path>
          <path
            d="M493.653333 637.866667c-13.226667 13.226667-34.986667 13.226667-48.213333 0l-120.746667-120.746667c-13.226667-13.226667-13.226667-34.986667 0-48.213333 13.226667-13.226667 34.986667-13.226667 48.213334 0l120.746666 120.746666c13.226667 13.226667 13.226667 34.986667 0 48.213334z"
            fill="#E3E3E3"
            p-id="5217"
          ></path>
          <path
            d="M699.733333 432.213333l-206.506666 206.506667c-12.8 12.8-33.706667 12.8-46.933334 0-12.8-12.8-12.8-33.706667 0-46.933333L652.8 385.28c12.8-12.8 33.706667-12.8 46.933333 0 12.8 12.8 12.8 33.706667 0 46.933333z"
            fill="#E3E3E3"
            p-id="5218"
          ></path>
        </svg>
      </div>
      <div class="yanzhengma">
        <input
          type="text"
          placeholder="请输入验证码"
          class="input_t"
          id="code"
        />
        <van-button round size="small" class="btn" @click="getCode" id="btn"
          >获取验证码</van-button
        >
      </div>
    </div> -->
    <van-form label-width="50px" label-align="center">
      <van-field v-model="form.phone" name="用户名" placeholder="请输入手机号">
        <template #label>
          <van-icon name="phone-o" size="20" color="#fff" />
        </template>
      </van-field>
      <van-field
        v-model="form.code"
        name="密码"
        label="密码"
        placeholder="请输入验证码"
      >
        <template #label>
          <van-icon
            name="shield-o"
            size="20"
            color="#fff"
            style="line-height: 30px"
          />
        </template>
        <template #button>
          <van-button round size="small" class="btn" @click="getCode" id="btn"
            >获取验证码</van-button
          >
        </template>
      </van-field>
      <van-field name="radio" label="类型">
        <template #input>
          <van-radio-group v-model="form.type" direction="horizontal">
            <van-radio name="1" checked-color="#52bf90"
              ><span style="color: #fff">用户</span></van-radio
            >
            <van-radio name="2" checked-color="#52bf90"
              ><span style="color: #fff">企业</span></van-radio
            >
          </van-radio-group>
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button
          size="large"
          color="#4596FF"
          class="loginBtn"
          @click="onSubmit"
          >登录</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
import { login, getCode } from "@/api/home";

export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      form: {
        phone: "",
        code: "",
        type: "1",
      },
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // onSubmit() {},
    // 发送验证码
    async getCode() {
      if (this.form.phone) {
        let time = 60;
        const phone = this.form.phone;

        const res = await getCode({
          phone: phone,
          type: this.form.type,
          channel: 1,
        });
        if (res.data.code == 200) {
          document.getElementById("btn").disabled = true;
          Toast.success("发送成功");
          // 倒计时
          let timer = setInterval(function () {
            time--;
            document.getElementById("btn").innerHTML = `${time}秒后再试`;
            if (time <= 0) {
              time = 60;
              clearInterval(timer);
              document.getElementById("btn").disabled = false;
              document.getElementById("btn").innerHTML = "获取验证码";
            }
          }, 1000);

          this.$once("hook:beforeDestroy", () => {
            clearInterval(timer);
            timer = null;
          });
        }
      } else {
        Toast.fail("请输入手机号");
      }
    },
    async onSubmit() {
      const code = this.form.code;
      const phone = this.form.phone;
      if (code.trim().length <= 0 && phone.trim().length <= 0) {
        Toast.fail("请输入");
      } else {
        if (phone.trim().length <= 0) {
          Toast.fail("手机号不能为空");
        } else {
          let a = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
          var test = a.test(phone);
          if (!test) {
            Toast.fail("请输入正确手机号");
          } else if (code.trim().length <= 0) {
            Toast.fail("验证码不能为空");
          } else {
            const obj = {};
            obj.phone = phone;
            obj.code = code;
            obj.type = this.form.type;

            if (
              this.$store.state.userInfo &&
              this.$store.state.userInfo.openId
            ) {
              obj.openId = this.$store.state.userInfo.openId;
            } else {
              obj.openId = localStorage.getItem("openId");
            }
            this.$store.dispatch("login", obj);
          }
        }
      }
    },
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {
    // document.getElementById("phone").value = 13333333332;
  },
};
</script>

<style scoped lang="less">
.container {
  height: 100vh;
  width: 100%;
  background: url("~@/assets/img/geren/denglu.png") no-repeat;
  background-size: cover;
  padding-top: 110px;
  box-sizing: border-box;
  .logo {
    width: 150px;
    height: 150px;
    background: url("~@/assets/img/geren/logo.png") no-repeat;
    background-size: cover;
    margin: 0px 0 10px 25px;
  }
  .text {
    color: rgba(0, 0, 0, 1);
    font-size: 36px;
    margin-left: 30px;
    font-weight: 700;
    margin-bottom: 150px;
  }
  .box {
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 600px;
    height: 60px;
    padding: 20px 10px 0px 10px;
    border-bottom: 1px solid rgba(227, 227, 227, 1);
    .input_t {
      border: none;
      background: transparent;
      font-size: 24px;
      color: rgba(227, 227, 227, 1);
    }
    .input_t::placeholder {
      color: rgba(227, 227, 227, 1);
    }
    .yanzhengma {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
  .loginBtn {
    display: block;
    width: 600px;
    border-radius: 20px;
    margin: 200px auto 0;
  }
}
.van-cell {
  background: transparent;
}
::v-deep .van-field__control {
  color: #fff;
}
.btn {
  background-color: rgba(153, 197, 255, 1);
  border: none;
  color: #fff;
  height: 50px;
}
::v-deep .van-field__label {
  color: #fff;
}
</style>
